import Vue from "vue";
import Router from "vue-router";
import VueCookies from "vue-cookies";
import commons from "@/utils/commons.js";
import homeOld from "@/view/index/index.vue";
import Home from "@/view/index/index1.vue";

import login from "@/view/login/login.vue";
import register from "@/view/login/Register.vue";
import forgetPassword from "@/view/login/forgetPassword.vue";

import newsList from "@/view/news/newsList.vue";
// import newsListold from '@/view/news/newsList2.vue'

import newsDetail from "@/view/news/newsDetail.vue";
import newsListHire from "@/view/news/newsListHire.vue";
import newsListInform from "@/view/news/newsListInform.vue"

import recruitList from "@/view/recruitNotice/recruitList.vue";
// import recruitListold from "@/view/recruitNotice/recruitList1.vue"
import choosePostRecruitList from "@/view/choosePostNotice/recruitList.vue"

import recruitDetail from "@/view/recruitNotice/recruitDetail.vue";
import choosePostRecruitDetail from "@/view/choosePostNotice/recruitDetail.vue";

import mine from "@/view/mine/mine.vue";
import mineInfo from "@/view/mine/mineInfo.vue"; //个认信息
import mineMsg from "@/view/mine/mineMsg.vue"; //基本信息
import mineAttachment from "@/view/mine/mineAttachment.vue"; // 我的附件
import mineResume from "@/view/mine/mineResume.vue"; //我的简历
import mineSign from "@/view/mine/mineSign.vue"; //我的报名
import mineResumeSign from "@/view/mine/mineResumeSign.vue"; //我的投递简历
import mineChoosePostSign from "@/view/mine/mineChoosePostSign.vue"; //我的选岗
import mineEnterprise from "@/view/enterprise/mineEnterprise"; //我的企业
import mineRecruit from "@/view/mine/mineRecruit.vue"; //我的招聘
import phone from "@/view/phone/phone.vue"; //手机端提示

import adviser from "@/view/adviser/adviser.vue"; //出国留学

import specialist from "@/view/specialist/index.vue" // 讲师列表
import specialist1 from "@/view/specialist/index2.vue" // 讲师详情

import pay from "@/view/pay/pay.vue"; //支付

import examTest from "@/view/exam/examTest.vue";

import examCover from "@/view/exam/examCover.vue";
import examResult from "@/view/exam/examResult.vue";

import articleExamCover from "@/view/articleExam/index.vue";
import articleExamText from "@/view/articleExam/text.vue";

import registrationPage from "@/view/login/Register"; // 返回注册页
import enterpriseRegister from "@/view/enterprise/register.vue"; // 企业注册
import specialistRegister from "@/view/enterprise/specialist.vue"; // 专家库注册

import text from "@/view/text/text.vue"; //考试页面
import text1 from "@/view/text/text1.vue"; // 测试界面分辨率

import server from "@/view/server/shouye.vue"; //培训服务
import allCourse from "@/view/server/allCourse.vue"; //全部课程
import courseDetail from "@/view/server/courseDetail.vue"; //课程详情

import recruitmentIndex from "@/view/recruitment/index.vue"
import mutualSelection from '@/view/recruitment/mutualSelection.vue'

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      meta: {
        name: "",
        // 登录权限
        requiresAuth: false
      },
      component: Home
    },
    // {
    //     path: '/homeOld',
    //     name: 'homeOld',
    //     meta: {
    //         name: "",
    //         requiresAuth: false,
    //     },
    //     component: homeOld
    // },
    {
      path: "/login",
      name: "login",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: login
    },
    {
      path: "/register",
      name: "register",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: register
    },
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: forgetPassword
    },
    {
      path: "/phone",
      name: "phone",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: phone
    },
    {
      path: "/newsList",
      name: "newsList",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: newsList
    },
    // {
    //     path: '/newsListold',
    //     name: 'newsListold',
    //     meta: {
    //         name: "",
    //         requiresAuth: false,
    //     },
    //     component: newsListold
    // },
    {
      path: "/newsDetail",
      name: "newsDetail",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: newsDetail
    },
    {
      path: "/newsListHire",
      name: "newsListHire",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: newsListHire
    },
    {
      path: "/newsListInform",
      name: "newsListInform",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: newsListInform
    },
    {
      path: "/recruitList",
      name: "recruitList",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: recruitList
    },
    // {
    //     path: '/recruitListold',
    //     name: 'recruitListold',
    //     meta: {
    //         name: "",
    //         requiresAuth: false,
    //     },
    //     component: recruitListold
    // },

    {
      path:"/recruitmentIndex",
      name:"recruitmentIndex",
      meta:{
        name:"",
        requiresAuth:false
      },
      component:recruitmentIndex,
    },
    {
      path: "/mutualSelection",
      name: "mutualSelection",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: mutualSelection
    },

    {
      path: "/recruitDetail",
      name: "recruitDetail",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: recruitDetail
    },
    {
      path: "/choosePostRecruitList",
      name: "choosePostRecruitList",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: choosePostRecruitList
    },
    {
      path: "/choosePostRecruitDetail",
      name: "choosePostRecruitDetail",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: choosePostRecruitDetail
    },
    {
      path: "/pay",
      name: "pay",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: pay
    },

    {
      path: "/examTest",
      name: "examTest",
      meta: {
        name: "",
        requiresAuth: true
      },
      component: examTest
    },

    {
      path: "/text",
      name: "text",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: text
    },
    {
      path: "/text1",
      name: "text1",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: text1
    },

    {
      path: "/articleExamCover",
      name: "articleExamCover",
      meta: {
        name: "",
        requiresAuth: true
      },
      component: articleExamCover
    },

    {
      path: "/articleExamText",
      name: "articleExamText",
      meta: {
        name: "",
        requiresAuth: true
      },
      component: articleExamText
    },

    {
      path: "/examCover",
      name: "examCover",
      meta: {
        name: "",
        requiresAuth: true
      },
      component: examCover
    },
    {
      path: "/examResult",
      name: "examResult",
      meta: {
        name: "",
        requiresAuth: true
      },
      component: examResult
    },
    {
      path: "/server",
      name: "server",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: server
    },
    {
      path: "/allCourse",
      name: "allCourse",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: allCourse
    },
    {
      path: "/courseDetail",
      name: "courseDetail",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: courseDetail
    },
    {
      path: "/adviser",
      name: "adviser",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: adviser
    },
    {
      path: "/specialist",
      name: "specialist",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: specialist
    },
    {
      path: "/specialist1",
      name: "specialist1",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: specialist1
    },

    {
      path: "/registrationPage",
      name: "registrationPage",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: registrationPage
    },
    {
      path: "/enterpriseRegister",
      name: "enterpriseRegister",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: enterpriseRegister
    },
    {
      path: "/specialistRegister",
      name: "specialistRegister",
      meta: {
        name: "",
        requiresAuth: false
      },
      component: specialistRegister
    },
    {
      path: "/mine",
      name: "mine",
      component: mine,
      redirect: "/mine/mineMsg",
      children: [
        {
          path: "mineMsg",
          name: "mineMsg",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineMsg
        },
        {
          path: "mineInfo",
          name: "mineInfo",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineInfo
        },
        {
          path: "mineAttachment",
          name: "mineAttachment",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineAttachment
        },
        {
          path: "mineResume",
          name: "mineResume",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineResume
        },
        {
          path: "mineSign",
          name: "mineSign",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineSign
        },
        {
          path: "mineResumeSign",
          name: "mineResumeSign",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineResumeSign
        },
        {
          path: "mineChoosePostSign",
          name: "mineChoosePostSign",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineChoosePostSign
        },
        {
          path: "mineEnterprise",
          name: "mineEnterprise",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineEnterprise
        },
        {
          path: "mineRecruit",
          name: "mineRecruit",
          meta: {
            name: "",
            requiresAuth: true
          },
          component: mineRecruit
        }
      ]
    }
  ],
  scrollBehavior: () => ({ y: 0 })
});

router.beforeEach(async (to, from, next) => {
  from.meta.savedPosition = document.body.scrollTop || document.documentElement.scrollTop;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (VueCookies.get(commons.User.Authentication)) {
      next();
    } else {
      next({ path: "/login", query: { redirect: to.fullPath } });
    }
  } else {
    if (to.name == "login" && !to.query.redirect) {
      to.query.redirect = from.fullPath;
    }
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js